// extracted by mini-css-extract-plugin
export default {"sort":"BT-z","sortSelect":"CT-z","disabled":"DT-z"};